export default __webpack_public_path__ + "static/media/logo-bb.e571be36.png";